import { Icon } from "@iconify/react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdNotificationsOutline } from "react-icons/io";
import AvailabilityChip from "../chip/availabilityChip";
import HeaderSkeleton from "../skeletons/layout/headerSkeleton";
import { useEffect } from "react";
import { notificationClient } from "./../../network/lib/notification";
import Notification from "../notification";
import { useState } from "react";

function Header(props) {
  const { isLoading, role, notification } = props;
  const [notificationData, setNotificationData] = useState({});

  /*const fetchNotifications = () => {
    notificationClient.getAllUnread().then((res) => {
      setNotificationData(res.data.notifications);
    });
  }*/

  useEffect(() => {
    /*if (role === "admin") {
     fetchNotifications()
    }*/
  }, []);

  if (isLoading) {
    return <HeaderSkeleton />;
  }

  return (
    <header className={`modern-header ${role === "expert" ? "expert-header" : ""}`}>
      <div className="header-container">
        <div className="logo-section">
          <button
            className="burger-menu"
            onClick={() => props.setShowBatMenu(!props.showBatMenu)}
          >
            <GiHamburgerMenu />
          </button>
          <img src={props.logo} className="logo" alt="logo" />
        </div>

        <ul className="header-menu">
          {role === "expert" ? (
            !props.supportWebCalling ? (
              <li className="menu-item">
                <AvailabilityChip />
              </li>
            ) : (
              <li
                className="menu-item"
                onClick={() =>
                  window.open(`https://vocal.vooxhub.com/?room=${props.userId}`, "_blank")
                }
              >
                <Icon icon="ic:baseline-phone" className="icon" />
                <span>Prendre des appels</span>
              </li>
            )
          ) : null}

          <li className="language-selector">
            <Icon icon="ic:round-language" />
            <span>Français</span>
          </li>
          {/*role === "admin" && (
              <Notification notifications={notificationData} fetchNotifications={fetchNotifications}/>
            </>
          )*/}

          <li className="profile-section">
            <img
              src={props.userImage ? props.userImage : "/assets/profile.png"}
              alt="profile"
              className="profile-image"
            />
            <span className="profile-name">{props.userName}</span>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
